/* unplugin-vue-components disabled */import { render } from "./CardModal.vue?vue&type=template&id=b8ae221c"
import script from "./CardModal.vue?vue&type=script&lang=js"
export * from "./CardModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__